<template>
  <v-container class="app-container--width-max">
    <BaseStepper
      v-if="isShowStepperBase"
      class="mb-1"
      :key="isQuestionSteps"
      :steps="isQuestionSteps ? questionSteps : applicationSteps"
    />
    <BaseAlert
      color="var(--orange-100)"
      class="quote-expired-message"
      v-if="isExpired"
    >
      <div class="d-flex flex-no-wrap error-message">
        <div class="mr-3">
          <v-icon color="var(--orange-500)">mdi-alert</v-icon>
        </div>
        <div>
          <span class="font-weight-bold">Sorry!</span> This quote has expired.
          Please check all the details below are accurate and submit a new
          quote.
        </div>
      </div>
    </BaseAlert>
    <div class="mt-2 mx-3 mx-xl-0">
      <QuoteErrorAlert :isQuotationStage="isQuestionSteps" />
    </div>

    <div
      class="b2b-tl-journey__container white rounded-lg elevation-3 mx-3 mt-3 mx-xl-0"
    >
      <router-view />
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/common/eventbus.js";
import { handleValidationError } from "@/common/utils";
import { ROUTE_NAME } from "@/constants/route.constants";
import { QUESTIONS_MODULE } from "@/store/types/module-types";

export default {
  name: "B2BMPPILayout",
  components: {
    BaseStepper: () => import("@/components/BaseComponents/BaseStepper.vue"),
    BaseAlert: () => import("@/components/BaseComponents/BaseAlert.vue"),
    QuoteErrorAlert: () => import("@/components/QuoteErrorAlert.vue"),
  },
  data() {
    return {
      questionSteps: [
        {
          stepNumber: 1,
          label: "Your details",
          routeName: ROUTE_NAME.MPPI.B2B.YOUR_DETAILS,
        },
        {
          stepNumber: 2,
          label: "Cover details",
          routeName: ROUTE_NAME.MPPI.B2B.COVER_DETAILS,
        },
        {
          stepNumber: 3,
          label: "Your quotes",
          routeName: ROUTE_NAME.MPPI.B2B.QUOTATION_RESULT,
        },
      ],
      applicationSteps: [
        {
          stepNumber: 4,
          label: "Your application",
          routeName: ROUTE_NAME.MPPI.B2B.APPLICATION,
        },
        {
          stepNumber: 5,
          label: "Payment",
          routeName: ROUTE_NAME.MPPI.B2B.PAYMENT,
        },
        {
          stepNumber: 6,
          label: "Complete",
          routeName: ROUTE_NAME.MPPI.B2B.COMPLETE,
        },
      ],
    };
  },
  created() {
    // Listen for validation errors globally
    EventBus.$on("validation-error", handleValidationError);
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["isExpired", "isQuestionSteps"]),
    currentRouteName() {
      return this.$route.name;
    },
    isShowStepperBase() {
      return ![ROUTE_NAME.MPPI.B2B.COMPLETE].includes(this.currentRouteName);
    },
  },
};
</script>

<style lang="scss">
.b2b-mppi-journey__container {
  padding: 24px 16px 40px 16px !important;
  .radio-group__wrapper {
    max-width: 400px;
  }
}

@media screen and (min-width: $grid-breakpoints-sm) {
  .b2b-mppi-journey__container {
    padding: 40px !important;
  }
}

@media screen and (min-width: $grid-breakpoints-lg) {
  .b2b-mppi-journey__container {
    padding: 40px 40px 80px 40px !important;
  }
  .quote-result__container,
  .b2b-mppi-journey__container {
    margin-bottom: 80px !important;
  }
}
</style>
